const ServicePage = ({ children }) => (
  <div className="flex items-center justify-center w-screen h-screen text-xl font-light text-white bg-gradient-to-tr from-blue-900 to-pink-900">
    {children}
  </div>
);

export default ServicePage;
